<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ViessmannVitotrans353VT2_2d00"
    >
    </Simulation>
    <H4>Hinweis: Diese Simulation enthält keine CAN-Bus-Funktionen</H4>
    <H4>Hinweis: Codierebene 1 nur mit CENTER - Codierebene 2 nur mit ESCAPE</H4>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ViessmannVitotrans353VT2 from '@/device-products/ViessmannVitotrans353VT2.vue';
import DdsSensor from '@/device-products/DdsSensor.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
      {
        label: 'DDS', connections: [
          {
            id: 'Regler zu DDS 1',
            from: { deviceId: 0, uart: 1},
            to: { deviceId: 1, uart: 0},
          }
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: ViessmannVitotrans353VT2, deviceLabel: null },
      { id: 1, component: DdsSensor, deviceLabel: 'Volumenstromsensor', deviceColor: 'green', props: {
        defaultSensorType: 'Allengra',
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawFlow', value: 0.0 },
        ],
      }}
    ],
  }),
};
</script>

<style>

</style>
